export default "__VITE_ASSET__aGJUVw8j__"